import PurchasesActivity from './Index.vue';
export default PurchasesActivity;



// WEBPACK FOOTER //
// ./src/pages/profile/views/purchases/pages/purchases-activity/index.ts